import React, { Component } from "react";
import HelloWorld from "components/HelloWorld";

export default class SysInfo extends Component {
  render() {
    return <HelloWorld />;
  }
}
